import React from 'react';
import { ActivityIndicator } from 'react-native-paper';
import { COLORS } from '../../constants';

const LoadingIndicatorCommon = ({ loading }) => {
  return (
    <ActivityIndicator 
      style={styles.progressbar}
      animating={loading} 
      size={'large'}
      color={COLORS.textDark} />
  )

};

const styles = {
  progressbar: {
    position: 'absolute',
    left: '50%',
    top: '40%',
  }
};

export default LoadingIndicatorCommon;